var _excluded = ["desc", "children", "tabIndex", "className"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
export var VictoryAccessibleGroup = function (_ref) {
  var desc = _ref.desc,
      children = _ref.children,
      tabIndex = _ref.tabIndex,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "VictoryAccessibleGroup" : _ref$className,
      props = _objectWithoutProperties(_ref, _excluded);

  var descId = desc && (props["aria-describedby"] || desc.split(" ").join("-"));
  return desc ? /*#__PURE__*/React.createElement("g", {
    "aria-label": props["aria-label"],
    "aria-describedby": descId,
    className: className,
    tabIndex: tabIndex
  }, /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), children) : /*#__PURE__*/React.createElement("g", {
    "aria-label": props["aria-label"],
    "aria-describedby": props["aria-describedby"],
    className: className,
    tabIndex: tabIndex
  }, children);
};